import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE;

function SavedFileSelector({ onSelect, resetTrigger }) {
  const [files, setFiles] = useState([]);
  const [selected, setSelected] = useState("");

  // Fetch the list of saved files from backend once on mount
  useEffect(() => {
    const fetchFiles = async () => {
      console.log("📡 Fetching saved files from backend...");
      try {
        console.log("📡 API base:", API_BASE);
        const res = await fetch(`${API_BASE}/saved-files`);
        const data = await res.json();
        console.log("✅ Saved files received:", data.files);
        setFiles(data.files);
      } catch (error) {
        console.error("❌ Failed to fetch saved files:", error);
        setFiles([]);
      }
    };
    fetchFiles();
  }, []);

  // Reset selected option whenever resetTrigger changes
  useEffect(() => {
    console.log("🔄 Reset trigger received:", resetTrigger);
    setSelected("");
  }, [resetTrigger]);

  // Handle file selection
  const handleChange = (e) => {
    const value = e.target.value;
    console.log(`📂 User selected file: "${value}"`);
    setSelected(value);
    if (value) {
      onSelect(value);
    }
  };

  return (
    <div className="mb-4">
      <label className="block font-semibold mb-1">📁 Load Saved Example:</label>
      <select
        className="p-2 border rounded w-full"
        value={selected}
        onChange={handleChange}
      >
        <option value="">Select a saved .h5ad file...</option>
        {files.map((file) => (
          <option key={file} value={file}>
            {file}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SavedFileSelector;
